import React from "react";
import { styled } from "@mui/material/styles";
import { Button, Grid, Tabs, Typography } from "@mui/material";
import { Box } from "@mui/system";
import HourAvailable from "./HourAvailable";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  showModalReservationState,
  hourSelectedState,
  professionalSelectedState,
} from "src/store/reservation/reservationState";
import Icon from "@mui/material/Icon";
import MdPhone from "@mui/icons-material/Phone";
import { filterSearchSelectedState } from "src/SearchHours/state/atoms";
import ButtonWaitList from "src/WaitList/components/ButtonWaitList";
import {
  disabledSelectState,
  professionalWaitListState,
  specialitiesWaitListState,
  specialityWaitListState,
} from "src/WaitList/state/atoms";
import { ServiceWaitList } from "src/services/agenda/waitlist";
import AgendamientoInconcluso from "src/services/agenda/agendamientoInconcluso";
import { userState } from "src/store/user/userState";
import { valuesFormReservationGuestState } from "src/Patient/state/atoms";
import { agendamientoInconclusoState } from "../state/atoms";
import { cleanRut } from "src/shared/global/helpers";

const StyledTabs = styled((props) => <Tabs {...props} />)(({ theme }) => ({
  width: "100%",
  overflowX: "auto",
  "& .MuiTabs-scrollButtons": {
    display: "inherit",
  },
  ".Mui-disabled": {
    display: "none",
  },
  ".MuiButtonBase-root": {
    opacity: 1,
    minWidth: 72,
  },
}));

const ListHoursAvailables = ({ professional }) => {
  const setAgendamientoInconcluso = useSetRecoilState(
    agendamientoInconclusoState
  );
  const [, setShowModal] = useRecoilState(showModalReservationState);
  const [, setHourSelected] = useRecoilState(hourSelectedState);
  const [, setProfessionalSelected] = useRecoilState(professionalSelectedState);
  const [filterSearchSelected, setFilterSearchSelected] = useRecoilState(
    filterSearchSelectedState
  );
  const setProfessionalWaitList = useSetRecoilState(professionalWaitListState);
  const setSpecialityWaitList = useSetRecoilState(specialityWaitListState);
  const setSpecilitiesWaitlist = useSetRecoilState(specialitiesWaitListState);
  const [disabledSelect, setDisabledSelect] =
    useRecoilState(disabledSelectState);

  const handleClickOpenModalWaitList = (el) => async (ev) => {
    setHourSelected(el);
    setProfessionalWaitList({
      code: el.professional.ptdRut,
      value: el.professional.ptdNombre,
    });

    const speciality = el.speciality;

    if (speciality.code) {
      setSpecialityWaitList(el.speciality);
    } else {
      const specialitiesByProfessional =
        await ServiceWaitList.getSpecialitiesByProfessional(
          el.professional.ptdRut
        );

      setSpecilitiesWaitlist(specialitiesByProfessional.data.data);
      setDisabledSelect(false);
    }
  };

  const handleClickOpenModalReservation = (el) => (ev) => {
    console.log(el, "el");

    setAgendamientoInconcluso((prev) => ({
      ...prev,
      ptdRut: el.professional.ptdRut?.toString(),
      agpCorrel: el.professional.agpCorrel?.toString(),
    }));

    setHourSelected(el);
    setProfessionalSelected(el);
    setShowModal(true);
  };

  return (
    <Grid
      container
      direction={{
        sm: "row",
      }}
    >
      <Grid item xs={12}>
        <StyledTabs
          value={false}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="Horas disponibles"
        >
          {professional.horas.map((el) => {
            if (el.ageInicio === "00:00") {
              return (
                <Box
                  key={`${el.ageCorrel}_${el.ageInicio}`}
                  sx={{
                    display: "flex",
                    paddingTop: "12px",
                    color: "#288FF9",
                  }}
                >
                  <Typography
                    variant="button"
                    display="block"
                    sx={{
                      fontSize: { xs: "0.7rem", sm: "1rem" },
                    }}
                  >
                    {process.env.REACT_APP_FONO}
                  </Typography>
                </Box>
              );
            } else {
              return (
                <HourAvailable
                  click={handleClickOpenModalReservation({
                    professional,
                    hourSelected: el,
                  })}
                  key={`${el.ageCorrel}_${el.ageInicio}`}
                  hour={el.ageInicio}
                />
              );
            }
          })}
        </StyledTabs>
      </Grid>
      <Grid
        item
        sx={{
          width: "100%",
        }}
      >
        {professional.horas.map((el) => {
          if (el.ageInicio == "00:00" && professional.btnListaEspera == "S") {
            return (
              <Box
                key={`${el.ageCorrel}_${el.ageInicio}`}
                sx={{
                  color: "#288FF9",
                }}
              >
                <ButtonWaitList
                  onClick={handleClickOpenModalWaitList({
                    professional,
                    hourSelected: el,
                    speciality: filterSearchSelected.specialitySelected,
                  })}
                />
              </Box>
            );
          }
        })}
      </Grid>
    </Grid>
  );
};

export default ListHoursAvailables;
